module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-T8RVHHL"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
